import React from 'react';
import styled from 'styled-components';
import FileIcon from "./FileIcon";
import {ReactComponent as DownloadIcon} from 'assets/icons/download.svg';
import {hexToRgb} from 'utils/hexToRGBObject';
import {convertBytesToString} from 'utils/btyesString';
import shortMomentString from "../../../utils/shortMomentString";
import {MOMENT_TIME_LIMIT} from "../../../common/constants";
import Moment from "react-moment";

const FileItemContainer = styled.a`
  display: flex;
  margin: 0 12px;
  text-decoration: none;
  padding: 4px 0 4px 8px;
  align-items: center;
  border-radius: 10px;
  &:hover{
    background: rgba(${p => p.r}, ${p => p.g}, ${p => p.b}, 0.1);
  }
  &:hover svg{
      visibility: visible !important;
  }
`;

const ImageIcon = styled.div`
`

const FileDetailsContainer = styled.div`
  flex-grow: 1;
  margin: auto 0 auto 10px;
`;

const FileName = styled.div`
  font-size: 14px;
  line-height: 17px;
  color: #2F3C4E;
  margin-bottom: 4px;
`

const FileDetails = styled.div`
  display: flex;
`

const SizeText = styled.div`
  font-size: 10px;
  line-height: 12px;
  color: #2F3C4E;
  mix-blend-mode: normal;
  opacity: 0.3;
  margin-right: 10px;
`

const TimeText = styled.div`
  font-size: 10px;
  line-height: 12px;
  color: #2F3C4E;
  mix-blend-mode: normal;
  opacity: 0.3;
`

const FileItem = props => {
    const {attachment, bgColor} = props;
    const rgbColor = hexToRgb(bgColor);
    return (
        <FileItemContainer r={rgbColor.r} g={rgbColor.g} b={rgbColor.b} href={attachment.attachment.publicUrl} download>
            <FileIcon attachment={attachment.attachment}/>
            <FileDetailsContainer>
                <FileName>{attachment.attachment.name}</FileName>
                <FileDetails>
                    <SizeText>{convertBytesToString(attachment.attachment.size)}</SizeText>
                    <TimeText>
                        <Moment ago interval={10000} fromNow unix filter={shortMomentString}>
                            {attachment.createdAt > MOMENT_TIME_LIMIT ? attachment.createdAt / 1000 : attachment.createdAt}
                        </Moment>
                    </TimeText>
                </FileDetails>
            </FileDetailsContainer>
            <DownloadIcon style={{marginRight: "22px", visibility: "hidden"}} fill={"#525F76"}/>
        </FileItemContainer>
    )
}

export default FileItem;